import axios from "axios";
import EndpointFactory from "axios-endpoints";
import Cookie from "js-cookie";
import jwt_decode from "jwt-decode";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  responseType: "json",
});

axiosInstance.interceptors.request.use((config) => {
  config.headers.Authorization = `Bearer ${
    Cookie.get("jwtToken") ? Cookie.get("jwtToken") : null
  }`;
  config.headers.ContentType = "multipart/form-data";
  return config;
});

let decoded = {};
let uid;
if (Cookie.get("jwtToken")) {
  decoded = jwt_decode(Cookie.get("jwtToken"));
  uid = decoded.id;
}

const Endpoint = EndpointFactory(axiosInstance);

const fn = {
  images: (id = "") => new Endpoint(`/images/${id}`),
  productImages: (id = "") => new Endpoint(`/product-images/${id}`),
  productsImages: () => new Endpoint(`/products-images/`),
  uploads: (uid = "") => new Endpoint(`/uploads/${uid}`),
  categories: (id = "") => new Endpoint(`/categories/${id}`),
  manufacturers: (id = "") => new Endpoint(`/manufacturers/${id}`),
  products: (id = "") => new Endpoint(`/products/${id}`),
  categoryRelatedProducts: (id = "") =>
    new Endpoint(`/category-related-products/${id}`),
  relatedProducts: (id = "") => new Endpoint(`/related-products/${id}`),
  featuredProducts: (id = "") => new Endpoint(`/featured-products/${id}`),
  pages: (id = "") => new Endpoint(`/pages/${id}`),
  blog: (id = "") => new Endpoint(`/posts/${id}`),
  specs: (id = "") => new Endpoint(`/specs/${id}`),
  informations: (id = "") => new Endpoint(`/informations/${id}`),
  orders: (id = "") => new Endpoint(`/orders/${id}`),
  prices: (productId = "") => new Endpoint(`/actual-prices?customerUid=${uid}&productId=${productId}`),
  geoZones: (id = "") => new Endpoint(`geozones/${id}`),
  customerDocuments: () => new Endpoint(`customer-documents/${uid}`),
  customer: () => new Endpoint(`/customer/${uid}`),
  cart: () => new Endpoint(`/cart/${uid}`),
  addToCart: (id = "") => new Endpoint(`/cart/${id}`),
  cartProducts: () => new Endpoint(`/cart-products/${uid}`),
  deleteRowCart: (id = "") => new Endpoint(`/cart/${id}`),
  documents: (id = "") => new Endpoint(`/documents/${id}`),
  sendMail: (id = "") => new Endpoint(`/send-mail/${id}`),
  sendInvoice: (id = "") => new Endpoint(`/send-invoice/${id}`),
  banners: (id = "") => new Endpoint(`/banners/${id}`),
  promotions: (id = "") => new Endpoint(`/promotions/${id}`),
  manufacturerCategories: (id = "") =>
    new Endpoint(`manufacturer-categories/${id}`),
};

export default fn;
